export const filterAll = (a) => true

export const filterIsSmall = (course) => course.holes.length < 5

export const filterIsLarge = (course) => course.holes.length > 32

export const filterIsPrivate = (course) => course.priv

export const filterIsActive = (course) => course.active

export const filterHasLocation = (course) =>
  course.location !== null &&
  course.location.lat !== 0 &&
  course.location.lng !== 0

export const filterWrongHoleCount = (course) =>
  (course.holeCount !== course.holes.length) !== 0

export const filterIsZombieCourse = (course) =>
  //course.holes.length !== 9 &&
  course.holes.every(
    (hole) =>
      hole.par === 3 &&
      !hole.i1 &&
      !hole.i2 &&
      !hole.dist &&
      !hole.tee &&
      !hole.basket
  )

export const filterHasInvalidCountryAndState = (course) =>
  !course.country || (course.country.id === 236 && !course.state)
